import { lazyWithRetry } from '@/utils/lazyWithRetry'
import type { Routes } from '@/@types/routes'

/**
 * Auth routes accessible only to UNAUTHENTICATED users. The
 * publicRoute outlet redirects already-signed-in users to /dashboard,
 * so these are forms the user hits before they have a session.
 *
 * Callback/error/success routes that need to be reachable even with
 * an active session (e.g. clicking a verify-email link while already
 * signed in elsewhere) live in `authOpenRoute.ts` and are mixed into
 * `openRoutes` instead.
 */
const authRoute: Routes = [
    {
        key: 'signIn',
        path: `/sign-in`,
        component: lazyWithRetry(() => import('@/views/auth/SignIn')),
        authority: [],
    },
    {
        key: 'signUp',
        path: `/sign-up`,
        component: lazyWithRetry(() => import('@/views/auth/SignUp')),
        authority: [],
    },
    {
        key: 'forgotPassword',
        path: `/forgot-password`,
        component: lazyWithRetry(() => import('@/views/auth/ForgotPassword')),
        authority: [],
    },
]

export default authRoute
